<!-- html code for cancel button  -->
<mat-dialog-content class="mat-typography" role="dialog">
   <div class="modal-body pr-4">
       <ng-container>
          <h2 class="addressLabel">{{'popupMessages.cancelMsg' | translate}}</h2>
       </ng-container>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end" class="modal-footer">
 <button  mat-button class="btn btn-secondary mr-2 " tabindex="0" style="border-color: #C41F3E;background-color: white;color:#C41F3E"  mat-dialog-close>Cancel</button>
 <button mat-button [mat-dialog-close]="true"  class="btn cacelBtn" style="color:white;background: #C41F3E;border: 1px solid #C41F3E;" cdkFocusInitial (click)="dismissModal()" >{{'popupMessages.sessiontitleclose' | translate}}</button>
</mat-dialog-actions>
